var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _image, _image2, _image3, _image4, _image5, _image6, _image7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissionRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 163 136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.16,0,0,0.16,-2934.03,-2518.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09944,0,0,1.09944,18246.4,12495.7)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333622,0,0,-0.333349,301.679,694)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M847.998,1042.21C848.239,1115.3 830.753,1187.36 797.042,1252.2C781.036,1282.65 766.438,1301.58 755.078,1313.19C746.297,1322.51 732.569,1325.22 720.908,1319.94C716.361,1318.33 712.255,1315.68 708.918,1312.2C693.721,1296.45 679.993,1275.63 668.004,1253.46C632.537,1187.11 614.129,1112.96 614.44,1037.71L614.44,992.532L585.485,992.532L585.485,1517.51C585.485,1627.54 560.876,1736.11 512.678,1832.49C489.838,1878.12 469.006,1906.47 452.97,1923.9C445.11,1932.86 433.773,1938 421.857,1938C409.941,1938 398.603,1932.86 390.744,1923.9C369.043,1900.29 349.47,1869.09 332.354,1835.91C281.668,1737.55 255.921,1625.92 255.921,1512.62L255.921,992.532L230.892,992.532L230.892,1039.87C231.203,1115.12 212.795,1189.27 177.329,1255.62C165.339,1277.76 151.611,1298.58 136.414,1314.36C127.439,1323.82 113.383,1326.39 101.644,1320.72L102.693,1320.15C99.023,1318.52 95.704,1316.2 92.922,1313.31C81.682,1301.7 67.084,1282.77 50.958,1252.32C17.247,1187.48 -0.239,1115.42 0.002,1042.33L0.002,257.448L89.325,257.448L79.583,192.921L79.583,0L152.6,0L152.6,192.921L142.859,257.448L230.892,257.448L230.892,972.223L255.921,972.223L255.921,260.657L327.259,260.657L317.008,192.951L317.008,0L390.054,0L390.054,192.921L379.803,260.627L475.93,260.627L465.679,192.921L465.679,0L538.726,0L538.726,192.921L528.474,260.627L585.425,260.627L585.425,972.223L614.38,972.223L614.38,256.368L637.85,256.368L637.85,257.448L715.452,257.448L705.711,192.921L705.711,0L778.758,0L778.758,192.921L769.016,257.448L847.998,257.448L847.998,1042.21Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 0,
    y: 0,
    width: "848px",
    height: "1938px",
    transform: "matrix(16.96,0,0,17,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,316.37,3385.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.37,180.86L357.44,180.86L353.32,152.85L338.49,152.85L334.37,180.86Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,422.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.34,177.57L354.47,177.57L353.32,169.74L338.49,169.74L337.34,177.57Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-79.15,3385.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.13,180.86L555.2,180.86L551.08,152.85L536.25,152.85L532.13,180.86Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,422.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.1,177.57L552.23,177.57L551.08,169.74L536.25,169.74L535.1,177.57Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,166.4,3385.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.35,180.86L432.43,180.86L428.31,152.85L413.47,152.85L409.35,180.86Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,422.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.32,177.57L429.46,177.57L428.31,169.74L413.47,169.74L412.32,177.57Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,72.47,3385.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.32,180.86L479.39,180.86L475.27,152.85L460.44,152.85L456.32,180.86Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,422.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.29,177.57L476.43,177.57L475.27,169.74L460.44,169.74L459.29,177.57Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2901.26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.44,
    y: 405.82,
    width: 164.8,
    height: 6.59,
    style: {
      fill: "rgb(102,103,116)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,3026.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.72,176.843C545.959,174.899 543.458,173.79 540.835,173.79C538.212,173.79 535.711,174.899 533.95,176.843C529.15,181.953 524.82,188.713 521.03,195.903C509.815,217.525 504.012,241.545 504.12,265.903L504.12,519.593L577.05,519.593L577.05,264.853C577.142,241.163 571.621,217.789 560.94,196.643C555.88,186.763 551.27,180.613 547.72,176.843Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,3026.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.59,176.843C340.351,174.899 342.852,173.79 345.475,173.79C348.098,173.79 350.599,174.899 352.36,176.843C357.16,181.953 361.49,188.713 365.28,195.903C376.495,217.525 382.298,241.545 382.19,265.903L382.19,519.593L309.24,519.593L309.24,264.853C309.148,241.163 314.669,217.789 325.35,196.643C330.4,186.763 335.01,180.613 338.59,176.843Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.999989,0.00462423,-0.00462423,-0.999989,1010.08,3717.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.811,423.08L382.111,423.08L382.209,401.74L364.91,401.66L364.811,423.08Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.999989,0.00462156,-0.00462156,-0.999989,1010.08,3717.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.061,423.08L521.371,423.08L521.469,401.74L504.16,401.66L504.061,423.08Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,75.0653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.25,197.125C361.47,189.935 357.13,183.175 352.33,178.065C349.542,174.986 345.046,174.14 341.33,175.995C342.372,176.515 343.313,177.216 344.11,178.065C348.91,183.175 353.24,189.935 357.03,197.125C368.245,218.747 374.048,242.767 373.94,267.125L373.94,520.795L382.18,520.795L382.18,267.155C382.287,242.786 376.477,218.754 365.25,197.125Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,76.5092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.59,196.381C531.37,189.191 535.71,182.431 540.51,177.321C541.409,176.354 542.494,175.578 543.7,175.041C540.044,173.44 535.774,174.358 533.1,177.321C528.3,182.431 523.97,189.191 520.18,196.381C508.965,218.003 503.162,242.023 503.27,266.381L503.27,520.051L510.69,520.051L510.69,266.421C510.573,242.051 516.372,218.016 527.59,196.381Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1008.18,4246.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.37,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    style: {
      fill: "url(#_Linear3)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1008.18,4246.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.35,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    style: {
      fill: "url(#_Linear4)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1008.18,4246.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.32,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    style: {
      fill: "url(#_Linear5)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1008.18,4246.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.13,
    y: 617.2,
    width: 23.07,
    height: 62.62,
    style: {
      fill: "url(#_Linear6)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2824.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.29,179.404C449.85,176.504 446.254,174.83 442.465,174.83C438.676,174.83 435.08,176.504 432.64,179.404C425.79,187.063 419.64,197.193 414.2,207.973C398.2,239.914 390.06,276.163 390.06,312.924L390.06,720.013L494.15,720.013L494.15,311.284C494.15,275.563 486.38,240.284 471.15,209.073C463.94,194.263 457.36,185.063 452.29,179.404Z",
    style: {
      fill: "rgb(241,241,241)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2403.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.23,645.33L457.54,645.33C463.615,645.33 468.54,650.255 468.54,656.33L468.54,659.22C468.54,665.295 463.615,670.22 457.54,670.22L425.23,670.22C419.155,670.22 414.23,665.295 414.23,659.22L414.23,656.33C414.23,650.255 419.155,645.33 425.23,645.33Z",
    style: {
      fill: "rgb(115,93,208)",
      fillRule: "nonzero"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333371,0,0,-0.333738,136.095,770)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1645.3,290.857C1624.05,418.827 1507.91,508.992 1378.52,497.963C1249.12,486.933 1149.95,378.415 1150.72,248.698L1150.72,245.043C1141.51,243.649 1132.39,241.698 1123.42,239.2C1099.87,332.888 1019.6,401.466 923.287,410.175C826.978,418.885 735.681,365.823 695.668,277.883C675.546,285.637 654.412,290.46 632.915,292.205C629.487,311.649 623.737,330.611 615.787,348.687C608.049,466.965 510.556,559.411 391.905,560.98C273.255,562.549 173.347,472.712 162.478,354.679C150.7,329.766 143.177,303.059 140.22,275.665C32.356,230.837 -24.017,111.714 9.765,0L1832.3,0C1851.53,63.658 1841.88,132.534 1805.91,188.482C1769.94,244.43 1711.25,281.84 1645.3,290.857Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1842,
    height: 561
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-17.0522,-0,0,-17.0335,2366.99,2307.2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 31.066,
    y: 102.718,
    width: "108.021px",
    height: "32.935px",
    transform: "matrix(0.991019,0,0,0.998036,0,0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,76.1201,3881.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.71,
    cy: 659.35,
    rx: 72.83,
    ry: 72.83,
    style: {
      fill: "url(#_Linear10)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,49.17,3908.45)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.35,
    cy: 686.66,
    rx: 79.75,
    ry: 79.75,
    style: {
      fill: "url(#_Linear11)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,-274.93,4232.55)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.45,
    cy: 686.66,
    rx: 79.75,
    ry: 79.75,
    style: {
      fill: "url(#_Linear12)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,-277.84,4235.46)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 592.44,
    cy: 693.58,
    rx: 72.83,
    ry: 72.83,
    style: {
      fill: "url(#_Linear13)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1145.59,4409.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.55,752.9C647.574,729.536 636.367,707.584 617.43,693.9L532,693.9C504.095,714.068 494.118,751.017 508.077,782.491C522.037,813.964 556.122,831.37 589.803,824.224C623.483,817.077 647.564,787.33 647.54,752.9L647.55,752.9Z",
    style: {
      fill: "url(#_Linear14)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1145.59,4453.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.06,758.53C555.068,751.375 554.016,744.257 551.94,737.41L412.51,737.41C405.864,759.399 409.982,783.236 423.62,801.721C437.258,820.206 458.819,831.173 481.79,831.31L482.24,831.36C484.28,831.36 486.303,831.277 488.31,831.11C495.192,830.55 501.958,829.004 508.4,826.52C536.518,815.687 555.064,788.662 555.06,758.53Z",
    style: {
      fill: "url(#_Linear15)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1145.59,4467.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.87,758.56C737.87,756.38 737.773,754.223 737.58,752.09C737.588,752.06 737.588,752.03 737.58,752L592.5,752C592.3,754.16 592.2,756.35 592.2,758.55C592.174,794.568 618.504,825.184 654.12,830.55C657.721,831.092 661.358,831.366 665,831.37C666.86,831.37 668.71,831.3 670.54,831.17C697.13,829.136 720.487,812.744 731.44,788.43C731.74,787.77 732.03,787.1 732.3,786.43C735.978,777.599 737.871,768.127 737.87,758.56Z",
    style: {
      fill: "url(#_Linear16)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1145.59,4453.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.52,758.54C875.528,751.385 874.476,744.267 872.4,737.42L733,737.42C729.63,748.619 728.989,760.462 731.13,771.96C731.25,772.59 731.37,773.23 731.51,773.85C738.741,807.402 768.408,831.358 802.73,831.36C805.02,831.36 807.27,831.26 809.5,831.04C810.5,830.96 811.5,830.84 812.5,830.71C848.599,825.798 875.517,794.972 875.52,758.54Z",
    style: {
      fill: "url(#_Linear17)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,1145.59,4448.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.13,733.051C428.37,733.811 428.58,734.571 428.79,735.341C435.539,760.582 428.26,787.503 409.712,805.904C391.164,824.305 364.186,831.37 339,824.421C336.103,823.626 333.26,822.644 330.49,821.481C295.938,807.107 277.882,768.904 288.71,733.081L428.13,733.081L428.13,733.051Z",
    style: {
      fill: "url(#_Linear18)",
      fillRule: "nonzero"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334,0,0,-0.334,697.07,616.58)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,40C80,17.908 62.091,0 40,0C17.909,0 0,17.908 0,40C0,62.091 17.909,80 40,80C62.091,80 80,62.091 80,40Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip19)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image20",
    x: 0,
    y: 0,
    width: "80px",
    height: "80px",
    transform: "matrix(16,0,0,16,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,-305.52,4263.14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 710.43,
    cy: 603.27,
    r: 12.38,
    style: {
      fill: "url(#_Linear21)"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334943,0,0,-0.334943,757.04,746.7)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87,43.5C87,19.476 67.524,0 43.5,0C19.476,0 0,19.476 0,43.5C0,67.524 19.476,87 43.5,87C67.524,87 87,67.524 87,43.5Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip22)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image23",
    x: 0,
    y: 0,
    width: "87px",
    height: "87px",
    transform: "matrix(17.4,0,0,17.4,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,-495.61,4453.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 771.61,
    cy: 732.18,
    r: 13.84,
    style: {
      fill: "url(#_Linear24)"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333542,0,0,-0.333542,132.16,665.11)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,48C96,21.49 74.51,0 48,0C21.49,0 0,21.49 0,48C0,74.51 21.49,96 48,96C74.51,96 96,74.51 96,48Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip25)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image26",
    x: 0,
    y: 0,
    width: "96px",
    height: "96px",
    transform: "matrix(16,0,0,16,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,210.86,3746.76)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.17,
    cy: 649.15,
    r: 15.29,
    style: {
      fill: "url(#_Linear27)"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333579,0,0,-0.333993,672.435,87.8402)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.482,210.843C225.843,224.883 212.514,236.669 197.271,245.514C149.345,273.021 89.319,267.701 46.992,232.195C4.665,196.689 -10.951,138.558 7.897,86.66C26.745,34.762 76.044,0.147 131.319,0C134.107,0 136.895,0 139.653,0.269C188,3.316 230.765,32.638 250.985,76.605C271.204,120.572 265.611,172.078 236.422,210.693L236.482,210.843Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip28)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image29",
    x: 0,
    y: 0,
    width: "263px",
    height: "263px",
    transform: "matrix(17.5333,0,0,17.5333,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-685.404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.77,729.274C757.772,751.18 740.752,769.316 718.89,770.704C718.02,770.764 717.14,770.794 716.26,770.794C698.815,770.784 683.238,759.867 677.275,743.473C671.312,727.079 676.235,708.706 689.597,697.49C702.959,686.275 721.907,684.61 737.02,693.324C741.829,696.117 746.034,699.84 749.39,704.274C754.84,711.468 757.783,720.249 757.77,729.274Z",
    style: {
      fill: "rgb(135,118,217)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-722.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.04,740.33C703.896,741.255 701.826,742.345 699.85,743.59C698.53,744.322 697.398,745.349 696.54,746.59C695.684,747.862 695.653,749.517 696.46,750.82C697.46,752.2 699.46,752.42 701.13,752.51C704.255,753.174 707.495,752.104 709.61,749.71L713.18,746.47C714.42,745.35 715.78,743.8 715.24,742.22C714.83,741.01 713.47,740.42 712.24,740.22C709.172,739.616 705.988,740.176 703.31,741.79",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1400.87,751.39)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 691.13,
    cy: 709.74,
    r: 2.18,
    style: {
      fill: "rgb(249,118,85)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1459.14,781.98)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 735.56,
    cy: 723.58,
    r: 8.01,
    style: {
      fill: "rgb(249,118,85)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0339843,-0.999422,-0.999422,0.0339843,1514.06,731.132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.847,740.017C732.026,740.303 727.453,745.106 727.454,750.933C727.454,756.761 732.026,761.564 737.847,761.85C743.668,762.136 748.689,757.805 749.261,752.006C746.291,747.29 742.411,743.214 737.847,740.017Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.449375,-0.893343,-0.893343,0.449375,1686.36,417.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.993,679.209C727.049,690.296 726.467,703.484 731.412,715.052C731.944,714.841 732.475,714.607 732.993,714.346C739.63,711.005 743.818,704.208 743.818,696.777C743.818,689.347 739.63,682.55 732.993,679.209Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1148.14,1067.48)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 722.81,
    cy: 425.33,
    r: 5.1,
    style: {
      fill: "rgb(102,103,116)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,334.14,521.48)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.81,
    cy: 291.33,
    r: 5.1,
    style: {
      fill: "rgb(102,103,116)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1182.14,1427.48)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 919.81,
    cy: 262.33,
    r: 5.1,
    style: {
      fill: "rgb(102,103,116)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,792.72,554.74)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 288.73,
    cy: 503.99,
    r: 5.1,
    style: {
      fill: "rgb(102,103,116)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,893.23,420.73)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.98,
    cy: 621.25,
    r: 5.1,
    style: {
      fill: "rgb(102,103,116)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,516.69,508.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.77,
    cy: 388.92,
    r: 5.1,
    style: {
      fill: "rgb(102,103,116)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,6.0002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.18,381.07L844.64,381.07L844.64,376.54L842.79,376.54L842.79,381.07L838.25,381.07L838.25,382.93L842.79,382.93L842.79,387.46L844.64,387.46L844.64,382.93L849.18,382.93L849.18,381.07Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.18,538.07L920.64,538.07L920.64,533.54L918.79,533.54L918.79,538.07L914.25,538.07L914.25,539.93L918.79,539.93L918.79,544.46L920.64,544.46L920.64,539.93L925.18,539.93L925.18,538.07Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-483.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.55,625.79L597.01,625.79L597.01,621.25L595.16,621.25L595.16,625.79L590.62,625.79L590.62,627.64L595.16,627.64L595.16,632.18L597.01,632.18L597.01,627.64L601.55,627.64L601.55,625.79Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-44.9798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.65,406.56L795.11,406.56L795.11,402.03L793.26,402.03L793.26,406.56L788.73,406.56L788.73,408.42L793.26,408.42L793.26,412.95L795.11,412.95L795.11,408.42L799.65,408.42L799.65,406.56Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,256.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.59,255.8L629.06,255.8L629.06,251.27L627.21,251.27L627.21,255.8L622.67,255.8L622.67,257.66L627.21,257.66L627.21,262.19L629.06,262.19L629.06,257.66L633.59,257.66L633.59,255.8Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-365.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.93,566.79L164.39,566.79L164.39,562.26L162.54,562.26L162.54,566.79L158,566.79L158,568.64L162.54,568.64L162.54,573.18L164.39,573.18L164.39,568.64L168.93,568.64L168.93,566.79Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-247.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.93,507.79L6.39,507.79L6.39,503.26L4.54,503.26L4.54,507.79L0,507.79L0,509.64L4.54,509.64L4.54,514.18L6.39,514.18L6.39,509.64L10.93,509.64L10.93,507.79Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,123.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.56,322.08L227.02,322.08L227.02,317.54L225.17,317.54L225.17,322.08L220.64,322.08L220.64,323.93L225.17,323.93L225.17,328.47L227.02,328.47L227.02,323.93L231.56,323.93L231.56,322.08Z",
    style: {
      fill: "rgb(102,103,116)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,1,0,-495.61,4453.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 771.61,
    cy: 732.18,
    r: 13.84,
    style: {
      fill: "url(#_Linear30)"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.335119,0,0,-0.334721,231.285,381.75)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.423,100.024C107.381,106.702 101.061,112.308 93.833,116.515C71.108,129.758 42.531,127.326 22.367,110.431C2.202,93.537 -5.228,65.803 3.786,41.073C12.801,16.343 36.326,-0.08 62.62,0L66.559,0C89.468,1.467 109.724,15.404 119.304,36.29C128.884,57.176 126.241,81.641 112.423,99.994L112.423,100.024Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip31)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image32",
    x: 0,
    y: 0,
    width: "125px",
    height: "125px",
    transform: "matrix(17.8571,0,0,17.8571,0,0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-49.8468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.03,410.717C272.03,421.15 263.922,429.787 253.51,430.447L252.26,430.447C243.953,430.439 236.538,425.238 233.7,417.432C230.862,409.625 233.206,400.877 239.568,395.535C245.93,390.194 254.953,389.4 262.15,393.547C264.439,394.877 266.441,396.648 268.04,398.757C270.646,402.198 272.048,406.401 272.03,410.717Z",
    style: {
      fill: "rgb(135,118,217)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-67.6736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.39,416.004C246.351,416.441 245.348,416.959 244.39,417.554C243.762,417.897 243.222,418.379 242.81,418.964C242.421,419.574 242.421,420.354 242.81,420.964C243.398,421.541 244.209,421.833 245.03,421.764C246.505,422.066 248.029,421.559 249.03,420.434L250.73,418.894C251.32,418.354 251.97,417.624 251.73,416.894C251.457,416.332 250.912,415.953 250.29,415.894C248.829,415.608 247.315,415.875 246.04,416.644",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,641.62,608.96)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.29,
    cy: 401.33,
    r: 1.04,
    style: {
      fill: "rgb(249,118,85)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,669.37,623.53)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 261.45,
    cy: 407.92,
    r: 3.82,
    style: {
      fill: "rgb(249,118,85)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0359079,-0.999355,-0.999355,0.0359079,692.89,596.451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.547,415.691C259.777,415.825 257.6,418.111 257.6,420.884C257.6,423.658 259.776,425.943 262.547,426.078C265.317,426.213 267.706,424.15 267.975,421.389C266.561,419.149 264.716,417.212 262.547,415.691Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-19.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.43,391.87C264.987,396.774 259.5,399.847 253.52,400.22L253.52,399.39C253.509,395.834 255.511,392.578 258.691,390.984C261.87,389.39 265.677,389.733 268.52,391.87L268.43,391.87Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1008.18,2949.49)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.59,
    y: 564,
    width: 103,
    height: 4
  }))))))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "50px",
    height: "114px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAByCAYAAAARZ4LdAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACKklEQVR4nO1b0W7DIAzEwH/ty/rdldpi72EhYl4C68qEe/I91WoO+bANDrR0uVw+AgByjFFWOzEDcbUDs5CJCCIimZlX+zAFOBEhotU+TEEWEYyIwAiBSq0Yv7aTuoLFGIOIBBEJRBSIaLePnj2zNbfar3DP/Mgishs1y7RdyUff9ezqwF/Gepb7rUXRadbave+etf+Di9OiMDPEqoUTEW/jjcFrxBpgaiSD9Ize/ZoDzqsuyvKLU+wwyy9MsZdSICKC06KklDwiluA1Yg0wNYKzs8P0WjA7O0yvBZNaMMUOk1r7sXyMwswUQvhxL6Ht9tmRPZPbG2uvke3i5FfR0c+O7Fnc3liZiISZqe7w260Q1ZSrilubiKTOTinlJW6MUeqV2siPlqvtTEShbVO2u7rd1jWk7ZncV8bKKSUZzWpvJnrc0VgtdzTWMCK32y2EEKSU0gqUk8+Hdoc7HEtz/+pHTikJM5/Ool4xRrOqx+px22ePuCoi+xX1EfewRlq1uhfTbX/OuZv3PW7P1n6klPp+wByZ3u/31T5MAc4bYv1Nx7sDp42HEQKTWjDFDrP8wmyIKMdBGJUeXIg9uBBrgFm1cPaR7fDh7QFTIy7EGlyINbgQa4ARkvXZ7bsCJiIuxBpciDW4EGtwIdaAcxr/eDxW+zAFMEJgasSFWIMLsQYXYg041wp++GAMLsQaXIg1uBBrgBECsyHitCjX63W1D1MA8683mGKHEfIJb603FHtWp+8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.83498e-15,-62.63,-62.63,-3.83498e-15,345.9,679.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(230,230,230)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "rgb(253,211,118)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(249,118,85)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.83498e-15,-62.63,-62.63,-3.83498e-15,420.89,679.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(230,230,230)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "rgb(253,211,118)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(249,118,85)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.83498e-15,-62.63,-62.63,-3.83498e-15,467.86,679.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(230,230,230)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "rgb(253,211,118)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(249,118,85)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.83498e-15,-62.63,-62.63,-3.83498e-15,543.67,679.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(230,230,230)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "rgb(253,211,118)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(249,118,85)",
      stopOpacity: 1
    }
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "109px",
    height: "33px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAAAhCAYAAADTYiVBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACGUlEQVRoge2ZX2vbMBTFr2yRhLx1W8fo6GBf05F0ke34g65Qyui2xxDsRHtYXLrMSa3/NtMPBDGxdM/RyVWCQyBhRVEUN2PvbZrml4uaxMUi/yuc85vlcglt20LbtrBYLIBSCvv9Hg6HA6xWK8iyDHa7HSilYL1eg1IKOOdW4aXQDEDEdy7WkVL+NJnnNbRr5kwFx8ZVYD0m++A8NCGEtqmyLGcRoIm3Mej6p64KF0XxHgCg6zqjuU3T/HClxRdd103i68RaRB+WK6Yanmuf5+j4tgqNMebFSF3XkwrOl89zxvq2Oh7zPPdyXCDiBynls83819c2awH482mKsZjzjfGBzmbr6NENMYRXgPG6jELjnAcxUVXVmyZstPhe34QxmrRD22w2QU1st9tBEy51XKrhuo6tlp4shBDXuN7I0MHYoh1anuck5BBC3IbQMFQnhl/noSHiLSEEQo9QGqbgFxEHPzzGocVmjCFX6/uuZcPVdkTEj6GEXENK+R1gOnpC0Hse4mKnIeKn0/tTGFPT432c/A7yT6eVZXnx5kQchBBPr6//Co0xdhdWTmIsdV0/9q9fnj0yxj7HkZPQ5aXTOOf3MYUk3qaqqgeAU2iI+CWunMRYpJTf+uNxUn89JK5DEPFrbBEJPSj5Q2wdCQ2oUooopWLrSGhAj8djarOZQWFmD40TADTLstRpM4NC+rk/O9LxOENSp82Q33SDt48ARZAuAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-145.66,-8.9191e-15,-8.9191e-15,145.66,345.54,659.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-159.5,-9.76656e-15,-9.76656e-15,159.5,352.1,686.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-159.5,-9.76656e-15,-9.76656e-15,159.5,676.2,686.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-145.66,-8.9191e-15,-8.9191e-15,145.66,665.27,693.58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.07226e-15,-131.83,-131.83,-8.07226e-15,574.72,825.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.75339e-15,-93.96,-93.96,-5.75339e-15,482.23,831.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.86124e-15,-79.39,-79.39,-4.86124e-15,665.03,831.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.75339e-15,-93.96,-93.96,-5.75339e-15,802.69,831.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.75339e-15,-93.96,-93.96,-5.75339e-15,358.41,827.011)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image20",
    width: "5px",
    height: "5px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAP0lEQVQImV3JsRWAMAxDwa9YSzFbxobST6aBJtee9t4Xn7XWJJGr6k4CgCSqCs/MIwmAmQHAtjsJkvjT3R0OL6VKGKkr2k7yAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-24.76,-1.51611e-15,-1.51611e-15,24.76,722.81,603.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image23",
    width: "5px",
    height: "5px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASklEQVQImTXIsRUCMQxEwf2S7KJozkVDpCfvkcCEwznnBejniQhVRLz/Y1szowI+3a3MfKoKSarunr237r2yLUCRmRfwWsszY8Bfmt8gp3EawGYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-27.68,-1.69491e-15,-1.69491e-15,27.68,785.45,732.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(192,192,192)",
      stopOpacity: 1
    }
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image26",
    width: "6px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAPklEQVQImXWNQQqAQAzEMrSv8nH7awUvjVeFNddAkrXWwYaemUsFIAkAKg2cal5CNZ3krqpPpqpoYLaPP/EAuhcWtO1rNjUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-30.59,-1.8731e-15,-1.8731e-15,30.59,163.46,649.15)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image29",
    width: "15px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAqklEQVQokZ2RQZbFIAgEq4XkVnO03Dsvic3fjHnOX8xCV2JTCI2O4/hh8SRwL8NV9UgCoKqY78C/cdrukur3QUBJGsn60pjjlHQD2EYSA6wqWmsMDfgTSyIz86kqbBMRtNbovVNVRASSuK6LiCAi3sIRQdp+5lltv7OPxNHRt5a2n2HEaG8YMps0a69h+7735VXd9/KayYioZTgz1+HzPFdZctu29Z+BZfgDb02GuxDPh/gAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-27.68,-1.69491e-15,-1.69491e-15,27.68,785.45,732.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(245,245,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(214,214,214)",
      stopOpacity: 1
    }
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image32",
    width: "7px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAbklEQVQImU3N0Q3DQAzDUEq+bNXZMnYDHGIrH22BcgA+nef5kpQksh1AfMqyfSWhquhuAKqKmWEluQBmBklUlbo7ACvJ+zgO7b35P1QVK0l3t2wjCUmpKv3MJMnXyt4b2wIwMEkGmPu+YzszM8A8WttLoRs1FgYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionRocket);
export default __webpack_public_path__ + "static/media/mission_rocket.5f57b51f.svg";
export { ForwardRef as ReactComponent };